import React, { useEffect, useRef, useState } from "react";
import classes from "./indentdashboard.module.css";
import { ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import DashboardRouting from "./DashboardRouting";
import { useHistory, useLocation } from "react-router-dom";
// import DashboardDropdown from "./IndentRequestDashboard/DashboardDropdown";
import Loader from "../../Loader";
import { useIndentTracking } from "../hooks/useIndentTracking";
import useViewOnlyAccess from "../../../hooks/useViewOnlyAccess";
import { isMobile } from "../../../Constants";

const Indentdashboard = () => {
  const [selectedTab, setSelectedTab] = useState("request");
  const [show, setShow] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const { trackIndentEvent } = useIndentTracking();
  const redirectedRef = useRef(false); // Guard: only redirect once on mount

  const { dashboardAccess: reqDashboardAccess, loading: reqLoading } = useViewOnlyAccess('indent', 'lorri_indent_request', true);
  const { dashboardAccess: trackDashboardAccess, loading: trackLoading } = useViewOnlyAccess('indent', 'lorri_indent_tracking', true);

  const showReqButton = reqDashboardAccess;
  const showTrackButton = trackDashboardAccess;

  useEffect(() => {
    trackIndentEvent("indent dashboard", "user has visited indent dashboard");
  }, []);

  useEffect(() => {
    if (location.pathname.includes("/indents/requestdashboard")) {
      setSelectedTab("request");
    } else if (location.pathname.includes("/indents/trackingdashboard")) {
      setSelectedTab("tracking");
    }
  }, [location.pathname]);

  useEffect(() => {
    if (reqLoading || trackLoading) return;
    if (redirectedRef.current) return;
    redirectedRef.current = true;

    const onRequestDashboard = location.pathname.includes("/indents/requestdashboard");
    const onTrackingDashboard = location.pathname.includes("/indents/trackingdashboard");

    if (onRequestDashboard && !reqDashboardAccess && trackDashboardAccess) {
      // Landed on request dashboard but no access redirect to tracking
      history.replace({ pathname: "/indents/trackingdashboard" });
    } else if (onTrackingDashboard && !trackDashboardAccess && reqDashboardAccess) {
      // Landed on tracking dashboard but no access redirect to request
      history.replace({ pathname: "/indents/requestdashboard" });
    }
  }, [reqLoading, trackLoading, reqDashboardAccess, trackDashboardAccess]);

  const handleToggle = (type) => {
    setSelectedTab(type);
    if (type === "request") {
      history.push({ pathname: "/indents/requestdashboard" });
      trackIndentEvent(
        "indent dashboard",
        "user has clicked on indent request dashboard"
      );
    } else {
      history.push({ pathname: "/indents/trackingdashboard" });
      trackIndentEvent(
        "indent dashboard",
        "user has clicked on indent tracking dashboard"
      );
    }
  };

  return (
    <>
      <Loader show={show} />
      <span style={{ display: "flex", flexDirection: "row" }}>
        <span style={{ width: isMobile() ? "100%" : "400px", marginRight: isMobile() ? "20px" : "0px" }}>
          <div className={`${isMobile() ? "" : "mb-5"} ${classes["main-div"]} mt-4`}>
            <ToggleButtonGroup
              type="radio"
              name="options"
              value={selectedTab}
              className={classes["toggle-group"]}
            >
              {showReqButton && (
                <ToggleButton
                  value="request"
                  style={{
                    backgroundColor: selectedTab === "request" ? "#393185" : "transparent",
                    color: selectedTab === "request" ? "white" : "#808080",
                    fontWeight: selectedTab === "request" ? "bold" : "normal",
                    fontSize: isMobile() ? "9px" : "13px",
                    padding: isMobile() ? "2% 1%" : "1.1% 0%",
                    borderRadius: "11px",
                  }}
                  variant={selectedTab === "request" ? "#393185" : "light"}
                  className={isMobile() ? "px-2 text-wrap text-center" : "px-5 w-50 text-wrap text-center"}
                  onChange={() => handleToggle("request")}
                >
                  Indent Request Dashboard
                </ToggleButton>
              )}
              {showTrackButton && (
                <ToggleButton
                  value="tracking"
                  style={{
                    backgroundColor:
                      selectedTab === "tracking" ? "#393185" : "transparent",
                    color: selectedTab === "tracking" ? "white" : "#808080",
                    fontWeight: selectedTab === "tracking" ? "bold" : "normal",
                    fontSize: isMobile() ? "9px" : "13px",
                    padding: isMobile() ? "2% 1%" : "1.1% 0%",
                    borderRadius: "11px",
                  }}
                  className={isMobile() ? "px-2 text-wrap text-center" : "px-5 w-50 text-wrap text-center"}
                  variant={selectedTab === "expiredDOP" ? "#D3D3D3" : "light"}
                  onChange={() => handleToggle("tracking")}
                >
                  Indent Tracking Dashboard
                </ToggleButton>
              )}
            </ToggleButtonGroup>
          </div>
        </span>
      </span>
      <span className="col-md-12">
        <DashboardRouting />
      </span>
    </>
  );
};

export default Indentdashboard;
